export default __webpack_public_path__ + "static/media/SILA.7dee4ebb.png";